import makeStyles from '@ui/utils/makeStyles';

import { LikeButtonProps } from './LikeButton';

export default makeStyles<LikeButtonProps>()((_, { large, enabled, text, outlinedColor }) => ({
  button: {
    width: large ? 36 : 24,
    height: large ? 36 : 24,
    minWidth: 0,
  },
  heartIcon: {
    width: large ? 24 : 16,
    opacity: '0.2',
    fill: enabled ? '#ff0000' : '#080808',
    position: 'absolute',
    top: '50%',
    left: text ? 8 : '50%',
    transform: text ? 'translate(0, -50%)' : 'translate(-50%, -50%)',
    '&:hover': {
      opacity: '0.8'
    },
    transition: 'all .2s',
  },
  heartIconFull: {
    opacity: '1',
    fill: '#A3403D !important',
    '&:hover': {
      opacity: '1'
    },
    transition: 'all .2s'
  },
  heartIconOutlined: {
    width: large ? 20.3 : 10.3,
    fill: outlinedColor,
    position: 'absolute',
    top: '50%',
    left: text ? 8 : '50%',
    transform: text ? 'translate(0, -50%)' : 'translate(-50%, -50%)',
    transition: 'all .2s',
  },
  textButton: {
    width: 18,
    height: 18,
    top: '50%',
    transform: 'translate(0, -50%)',
  }
}));
